import { render, staticRenderFns } from "./PesquisaAmizade.vue?vue&type=template&id=832f2b66&scoped=true"
import script from "./PesquisaAmizade.vue?vue&type=script&lang=js"
export * from "./PesquisaAmizade.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAmizade.vue?vue&type=style&index=0&id=832f2b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832f2b66",
  null
  
)

export default component.exports